<template>
  <div>
    <div class="mb-10px">
      <el-input
        class="mr-10px !w-250px"
        clearable
        v-model="Keyword"
        placeholder="任务名称或编码"
      ></el-input>
      <el-button class="mr-10px" type="primary" @click="searchList"> 搜索</el-button>
      <el-button class="mr-10px" type="primary" @click="resetSearch"> 重置</el-button>
      <el-button class="mr-10px" @click="importData"> 导入</el-button>
      <el-button class="mr-10px" @click="exportData"> 导出</el-button>
      <el-button type="primary" @click="gotoPage"> 关联三维对象</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      height="calc(100% - 60px)"
      stripe
      v-loading="loading"
      ref="tableRef"
    >
      <el-table-column type="index" label="序号" :width="60"></el-table-column>
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width || 120"
        :fixed="item.fixed || false"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" align="left" width="200px" fixed="right">
        <template slot-scope="scope">
          <div>
            <el-button class="mr-10px" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" @click="deleteItem(scope.row)">删除</el-button>
          </div>
        </template></el-table-column
      >
    </el-table>

    <wiz-upload-file
      v-dialogDrag
      v-if="showUploadExcelDialog"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
      :uploadFileProps="uploadExcelProps"
    ></wiz-upload-file>

    <EditDialog
      v-if="currentItemProps.visible"
      :currentItemProps="currentItemProps"
      @close="closeDialog"
    ></EditDialog>
  </div>
</template>

<script>
import { TempFileApi } from '@wiz-api/file-management'
import { PlanTaskApi } from '@wiz-api/construction-schedule-management'
import dayjs from 'dayjs'
import EditDialog from '../components/editDialog'

const fileApi = new TempFileApi()
const planTaskApi = new PlanTaskApi()
export default {
  components: { EditDialog },
  data() {
    return {
      Keyword: '',
      columns: [
        // { prop: 'seqNo', label: '序号', width: 60 },
        { prop: 'code', label: '任务编码', width: 180 },
        { prop: 'name', label: '作业名称', width: 300 },
        { prop: 'weight', label: '任务权重' },
        { prop: 'planStartDt', label: '计划开始时间', width: 120 },
        { prop: 'planCompleteDt', label: '计划结束时间', width: 120 },
        { prop: 'planSchdule', label: '计划工时' },
        { prop: 'startDt', label: '实际开始时间', width: 120 },
        { prop: 'completeDt', label: '实际完成时间', width: 120 },
        { prop: 'complateRate', label: '实际完成百分比' },
        // { prop: 'name', label: '负责单位' },
        { prop: 'preTaskName', label: '前置节点', width: 180 },
        { prop: 'head', label: '相关负责人' },
        // { prop: 'name', label: '绑定模型' },
      ],
      loading: true,
      tableData: [],
      showUploadExcelDialog: false,
      uploadExcelProps: {
        visible: false, // 是否开启弹窗
        active: 1,
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
        downLoading: false, // 下载加载状态
        exportLoading: false, // 导出加载状态
      },
      currentItemProps: {
        id: null,
        visible: false,
      },
      page: {
        no: 1,
        size: 20,
        total: 0,
      },
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    async getList(loading = true, operate = false) {
      loading ? (this.loading = true) : null
      operate ? this.tableData = [] : null

      const [err, res] = await planTaskApi.getList({
        keyWords: this.Keyword,
        skipCount: operate ? 0 : (this.page.no - 1) * this.page.size,
        maxResultCount: operate ? (this.page.no) * this.page.size : this.page.size,
      })
      if (!err) {
        res.items.forEach((element) => {
          element.completeDt
            ? (element.completeDt = dayjs(element.completeDt).format('YYYY-MM-DD'))
            : ''
          element.planCompleteDt
            ? (element.planCompleteDt = dayjs(element.planCompleteDt).format('YYYY-MM-DD'))
            : ''
          element.planStartDt
            ? (element.planStartDt = dayjs(element.planStartDt).format('YYYY-MM-DD'))
            : ''
          element.startDt ? (element.startDt = dayjs(element.startDt).format('YYYY-MM-DD')) : ''
        })
        this.page.total = res.totalCount
        this.tableData.push(...res.items)
      }
      this.loading = false
    },
    resetSearch() {
      this.Keyword = ''
      this.tableData = []
      this.page.no = 1
      this.getList()
    },
    searchList() {
      this.page.no = 1
      this.tableData = []
      this.getList()
    },
    async exportData() {
      const [err, res] = await planTaskApi.callExport({ name: this.Keyword })
      if (!err) {
        this.downLoadBlob({
          name: '任务列表.xlsx',
          data: res,
        })
      }
    },
    // 导出
    downLoadBlob(
      arg = {
        name: '下载文件.xlsx',
        data: '',
      }
    ) {
      const blob = new Blob([arg.data])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${arg.name}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadExcelProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await planTaskApi.callImport({
        file: formData.get('file'),
      })
      if (!err) {
        this.$message.success('导入成功')
        this.uploadExcelProps.active = 2
        this.uploadExcelProps.buffer = res.buffer
        this.uploadExcelProps.successCount = res.successfullyCount
        this.uploadExcelProps.failureCount = res.failureCount
      }
      this.uploadExcelProps.btnLoading = false
      this.searchList()
    },
    // 下载导入结果
    async exportResults() {
      const binartData1 = atob(this.uploadFileProps.buffer)
      const int8Arr = new ArrayBuffer(binartData1.length)
      const unitResult = new Uint8Array(int8Arr)
      for (let i = 0; i < binartData1.length; i += 1) {
        unitResult[i] = binartData1.charCodeAt(i)
      }
      const blobFile = new Blob([unitResult], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      this.downLoadBlob({
        name: '导入结果.xlsx',
        data: blobFile,
      })
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await planTaskApi.getImportExcelTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '任务导入模板.xlsx',
          data: res,
        })
      }
    },
    importData() {
      this.showUploadExcelDialog = true
      this.uploadExcelProps.visible = true
      this.uploadExcelProps.active = 0
    },
    async deleteItem(row) {
      this.$confirm(this.$t('是否确定删除?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(async () => {
        const [err, res] = await planTaskApi.callDelete(row.id)
        if (!err) {
          this.getList(true, true)
        }
      })
    },
    gotoPage() {
      this.$router.push(`${this.basePath}/construction-schedule-management/associated-object`)
    },
    edit(row) {
      this.currentItemProps.id = row.id
      this.currentItemProps.visible = true
    },
    closeDialog() {
      this.currentItemProps.visible = false
      this.getList(true, true)
    },
    scrollEvent(evt) {
      const el = evt.srcElement
      console.log(
        el.scrollTop + el.clientHeight >= el.scrollHeight,
        '到底了------------------------'
      )

      if (
        this.tableData.length !== 0 &&
        el.scrollTop + el.clientHeight >= el.scrollHeight &&
        this.tableData.length < this.page.total
      ) {
        this.page.no = this.page.no + 1
        this.getList(false)
      }
    },
  },
  mounted() {
    this.getList()
    this.$nextTick(() => {
      this.$refs.tableRef.$el
        .querySelector('.el-table__body-wrapper')
        .addEventListener('scroll', this.scrollEvent)
    })
  },
  destroyed() {
    this.$refs.tableRef.$el
      .querySelector('.el-table__body-wrapper')
      .removeEventListener('scroll', this.scrollEvent)
  },
}
</script>

<style>
</style>
